import { useState, useEffect, useCallback, memo } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import SearchModal from "./SearchModal";

export const SearchButton = memo(() => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const initialQ = searchParams.get("q") ?? "";

  const [showModal, setShowModal] = useState(false);
  const [query, setQuery] = useState(initialQ);

  useEffect(() => {
    setQuery(initialQ);
  }, [initialQ]);

  const handleInputClick = useCallback((e) => {
    e.preventDefault();
    setShowModal(true);
  }, []);

  const handleOnModalClose = useCallback(() => {
    setShowModal(false);
    setQuery("");
  }, []);

  const handleModalQueryChange = useCallback((newQuery) => {
    setQuery(newQuery);
  }, []);

  return (
    <>
      <div
        onClick={handleInputClick}
        className={`nav-item cursor-pointer d-flex flex-column justify-content-center nav-item text-center text-secondary`}
        role="button"
        tabIndex={0}
        aria-label={t("search.title")}
      >
        <i className="bi bi-search fs-2" aria-hidden="true"></i>
        <span className="small">{t("search.title")}</span>
      </div>

      <SearchModal
        show={showModal}
        onHide={handleOnModalClose}
        query={query}
        onQueryChange={handleModalQueryChange}
      />
    </>
  );
});
